// 22.01.19 - The naming of the actions.
export const ActionTypes = {
  COMMON: {
    SET_LOADER_VISIBILITY: "SET_LOADER_VISIBILITY",
    SET_TOASTER_VISIBILITY: "SET_TOASTER_VISIBILITY",
    IS_LOGGED_IN: "IS_LOGGED_IN",
    ALLOW_FETCH_GRID_DATA: "ALLOW_FETCH_GRID_DATA",
    SET_CONFRIM_DAILOG_VISIBILITY: "SET_CONFRIM_DAILOG_VISIBILITY",
    CONFIRM_DIALOG_OK: "CONFIRM_DIALOG_OK",
    SET_PAGE_TITLE: "SET_PAGE_TITLE",
  },
  DETAIL: {
    FETCH_CASE: "GET_CASE",
    FETCH_CASE_SUCCEEDED: "FETCH_CASE_SUCCEEDED",
    GET_ALL_CASES: "GET_ALL_CASES",
    NEW_CASE: "NEW_CASE",
    SAVE_CASE: "SAVE_CASE",
    SAVE_CASE_FAILED: "SAVE_CASE_FAILED",
    SAVE_CASE_SUCCEEDED: "SAVE_CASE_SUCCEEDED",
    SELECT_CASE: "SELECT_CASE",
    UPDATE_CASE: "UPDATE_CASE",
    COUNTRIES_RECEIVED: "COUNTRIES_RECEIVED",
    ISSUE_TYPES_RECEIVED: "ISSUE_TYPES_RECEIVED",
    CLAIM_TYPES_RECEIVED: "CLAIM_TYPES_RECEIVED",
    GRANT_TYPES_RECEIVED: "GRANT_TYPES_RECEIVED",
    CLAIM_STATUS_RECEIVED: "CLAIM_STATUS_RECEIVED",
    NAVIGATE_HOME: "NAVIGATE_HOME",
    FORM_INVALID: "FORM_INVALID",
    SAVE_ATTACHMENT_DATA: "SAVE_ATTACHMENT_DATA",
    SAVE_ATTACHMENT_DATA_SUCCESS: "SAVE_ATTACHMENT_DATA_SUCCESS",
    SAVE_ATTACHMENT_DATA_FAILED: "SAVE_ATTACHMENT_DATA_FAILED",
    DOWNLOAD_ATTACHMENT: "DOWNLOAD_ATTACHMENT",
    SET_ATTACHMENT_DATA: "SET_ATTACHMENT_DATA",
    SET_ATTACHMENT_DATA_SHIPMENT: "SET_ATTACHMENT_DATA_SHIPMENT",
    SET_ATTACHMENT_DATA_SHIPMENT_INVENTORY:
      "SET_ATTACHMENT_DATA_SHIPMENT_INVENTORY",
    SET_ATTACHMENT_DATA_QMU: "SET_ATTACHMENT_DATA_QMU",
    SET_ATTACHMENT_DATA_INVENTORY: "SET_ATTACHMENT_DATA_INVENTORY",
    SET_ATTACHMENT_DATA_QMU_OER: "SET_ATTACHMENT_DATA_QMU_OER",
    DELETE_ATTACHMENT: "DELETE_ATTACHMENT",
    NAVIGATE_PRINT: "NAVIGATE_PRINT",
    ALLOW_EDIT: "ALLOW_EDIT",
    CASE_LOCK_UNLOCK: "CASE_LOCK_UNLOCK",
    FETCH_SOLUTION_USERS: "FETCH_SOLUTION_USERS",
    FETCH_SOLUTION_USERS_SUCCESS: "FETCH_SOLUTION_USERS_SUCCESS",
    CASE_LOCK_FOR_EDIT: "CASE_LOCK_FOR_EDIT",
    IS_LOCK_FOR_EDIT: "IS_LOCK_FOR_EDIT",
    REQUEST_FOR_CLOSE: "REQUEST_FOR_CLOSE",
    SET_CURRENT_USERNAME: "SET_CURRENT_USERNAME",
    IS_CURRENT_USER_SO: "IS_CURRENT_USER_SO",
    IS_CURRENT_USER_ST: "IS_CURRENT_USER_ST",
    IS_CHECKOUT_BY_DIFF_USER: "IS_CHECKOUT_BY_DIFF_USER",
    SAVE_SP_USER: "SAVE_SP_USER",
  },
  HOME: {
    GET_ALL_CASES: "GET_ALL_CASES",
    GET_ALL_CASES_BY_USER: "GET_ALL_CASES_BY_USER",
    SUCCESS_GET_ALL_CASES: "SUCCESS_GET_ALL_CASES",
    USER_DATA_RECEIVED: "USER_DATA_RECEIVED",
    NOTIFICATION: "NOTIFICATION",
    CLEAR_NOTIFICATION: "CLEAR_NOTIFICATION",
    FETCH_INITIAL_DATA: "FETCH_INITIAL_DATA",
    FETCH_USER_DATA: "FETCH_USER_DATA",
    FETCH_LOGGED_USER_DATA: "FETCH_LOGGED_USER_DATA",
    FETCH_LOGGED_USER_DATA_SUCCESS: "FETCH_LOGGED_USER_DATA_SUCCESS",
    GET_GRID_DATA: "GET_GRID_DATA",
    SUCCESS_GET_GRID_DATA: "SUCCESS_GET_GRID_DATA",
    SHOW_NO_DATA_MESSAGE: "SHOW_NO_DATA_MESSAGE",
    EXPORT_COMPLAINT: "EXPORT_COMPLAINT",
    EXPORT_CLAIM: "EXPORT_CLAIM",
    EXPORT_INCIDENT_REPORT: "EXPORT_INCIDENT_REPORT",
  },
};
